/** Initials for avatars: "Kanaf Bank" → "KB", "נועה לוי" → "נל". */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = [...parts[0]][0] ?? '';
  const second = parts.length > 1 ? ([...parts[parts.length - 1]][0] ?? '') : ([...parts[0]][1] ?? '');
  return (first + second).toUpperCase();
}

/** Milliseconds → "hh:mm:ss". */
export function formatDuration(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
}

export const EPISODE_STATUSES = ['processing', 'review', 'client', 'changes', 'approved', 'scheduled', 'published'] as const;
export type EpisodeStatus = (typeof EPISODE_STATUSES)[number];

export const PUBLICATION_STATUSES = ['draft', 'review', 'client', 'changes', 'scheduled', 'publishing', 'published', 'failed', 'cancelled'] as const;
export type PublicationStatus = (typeof PUBLICATION_STATUSES)[number];
/** Statuses a person may set on a post (`published` after posting by hand); `publishing` belongs to the publish job (amendment 20). */
export const SETTABLE_PUBLICATION_STATUSES = ['draft', 'review', 'client', 'changes', 'scheduled', 'published', 'failed', 'cancelled'] as const;

export const CHANNELS = ['yt', 'yts', 'ig', 'igs', 'tt', 'fb', 'li', 'x', 'th', 'pin', 'vimeo', 'tg', 'wa'] as const;
export type Channel = (typeof CHANNELS)[number];
